import { FormSchemaEntry } from '@gik/ui/Form';
import { RefObject } from 'react';
import ShippingFormSchema from '../ShippingForm/ShippingFormSchema';

const BillingFormSchema: (ref?: RefObject<HTMLElement>, isLoggedIn?: boolean) => FormSchemaEntry[] = (
  ref,
  isLoggedIn
) =>
  ShippingFormSchema(ref, isLoggedIn).concat([
    {
      label: 'Phone',
      name: 'phone',
      type: 'phone',
      required: true,
      minLength: 10,
      props: { maxLengthDisplay: false },
    },
  ]);

export default BillingFormSchema;
